import React from "react";
import Project from "./Project";
import { topProjects } from "../../../utils";

const Slider = () => {
  return (
    <div className="mobile_slider">
      {topProjects.map((project, index) => (
        <Project key={index} project={project} />
      ))}
    </div>
  );
};

export default Slider;
